import React from "react";
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Avatar,
  withStyles,
  Divider,
} from "@material-ui/core";
import { Link, withRouter } from "react-router-dom";
import { AccessTime, ExitToApp, TrendingUp } from "@material-ui/icons";
import { IconCalendario as DateRange } from "./icons/MateraIcons";
import { getColaborador } from "../utils/storage";
import { GoogleLogout } from "react-google-login";
import { fbConfig } from "../utils/fbConfig";
import { logoutApp } from "../contexts/GlobalProviders";
import { getBrowserFamily } from "../utils/browser";
import { useAuth } from "reactfire";
import { avatarUtils } from "../utils/avatarUtils";

const styles = () => ({
  avatar: {
    width: 150,
    height: 150,
    margin: "20px auto",
  },
  textProfile: {
    textAlign: "center",
  },
  divider: {
    margin: "20px 0",
  },
  menuContent: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",
  },
});

function MenuBar(props) {
  const [, setMenu] = props.menu;
  const { classes } = props;
  const onClick = () => setMenu(false);
  const colab = getColaborador();
  const auth = useAuth();
  return (
    <>
      <div className={classes.menuContent}>
        <MenuList>
          <Avatar
            alt={auth.currentUser?.displayName}
            src={avatarUtils(auth.currentUser?.photoURL, 200)}
            className={classes.avatar}
          />
          <ListItemText className={classes.textProfile}>
            {colab.area}
          </ListItemText>
          <ListItemText className={classes.textProfile}>
            {auth.currentUser?.displayName} ({colab.codigoColaborador})
          </ListItemText>
          <ListItemText className={classes.textProfile}>
            {auth.currentUser?.email}
          </ListItemText>
          <Divider className={classes.divider} />
          <MenuItem
            onClick={onClick}
            component={Link}
            to={"/resumo"}
            underline={"none"}
            color="textSecondary"
          >
            <ListItemIcon>
              <AccessTime />
            </ListItemIcon>
            <ListItemText>Resumo do Período</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={onClick}
            component={Link}
            to={"/saldo"}
            underline={"none"}
            color="textSecondary"
          >
            <ListItemIcon>
              <TrendingUp />
            </ListItemIcon>
            <ListItemText>Saldo de Horas</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={onClick}
            component={Link}
            to={"/apontamentos"}
            underline={"none"}
            color="textSecondary"
          >
            <ListItemIcon>
              <DateRange />
            </ListItemIcon>
            <ListItemText>Apontamentos</ListItemText>
          </MenuItem>
        </MenuList>
        <MenuList>
          <GoogleLogout
            clientId={fbConfig.clientId}
            onLogoutSuccess={() => logoutApp(props.history)}
            onFailure={console.log}
            cookiePolicy={"none"}
            approvalPrompt="force"
            responseType="id_token"
            accessType="online"
            isSignedIn
            redirectUri={fbConfig.redirect_uri}
            offline
            fetchBasicProfile={true}
            prompt="consent"
            uxMode={!getBrowserFamily("electron") ? "popup" : "redirect"}
            render={(props2) => (
              <MenuItem {...props2} className={classes.logoutMenuItem}>
                <ListItemIcon>
                  <ExitToApp />
                </ListItemIcon>
                <ListItemText>Logout</ListItemText>
              </MenuItem>
            )}
          />
        </MenuList>
      </div>
    </>
  );
}

export default withRouter(withStyles(styles)(MenuBar));
